import React, { useContext } from "react";
import { t } from "i18next";
import ModalMain from "../../../../../components/Modal/ModalMain";
import ModalHeader from "../../../../../components/Modal/ModalHeader";
import ModalFooter from "../../../../../components/Modal/ModalFooter";
import themeContext from "../../../../../context/theme/ThemeContext";

/**
 * Popup shown when radiologist clicks Preliminary.
 * - Mark as Preliminary → /save
 * - Release → /study/releasePreliminaryStudy
 */
const PreliminaryActionModal = ({
  isOpen,
  onClose,
  onMarkAsPreliminary,
  onRelease,
}) => {
  const { getThemeColor } = useContext(themeContext);

  if (!isOpen) {
    return null;
  }

  const DefaultButtonList = [
    {
      title: t("button.release"),
      onclick: onRelease,
    },
    {
      title: t("button.mark-as-preliminary"),
      onclick: onMarkAsPreliminary,
    },
  ];

  const modalDetails = {
    header: (
      <ModalHeader
        updatedModal={true}
        heading={t("button.preliminary")}
        handleCancel={onClose}
      />
    ),
    body: (
      <div
        className="global-modal-body"
        style={{ color: getThemeColor("primary-color") }}
      >
        {t("confirm-message.preliminary-action")}
      </div>
    ),
    footer: (
      <ModalFooter
        PrimaryButtonList={[]}
        DefaultButtonList={DefaultButtonList}
      />
    ),
    width: "500px",
  };

  return (
    <ModalMain
      updatedModal={true}
      showModal={isOpen}
      modalDetails={modalDetails}
    />
  );
};

export default PreliminaryActionModal;
